import { render, staticRenderFns } from "./patent.vue?vue&type=template&id=7f8af5e1&scoped=true"
import script from "./patent.vue?vue&type=script&lang=js"
export * from "./patent.vue?vue&type=script&lang=js"
import style0 from "./patent.vue?vue&type=style&index=0&id=7f8af5e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8af5e1",
  null
  
)

export default component.exports